/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type EnsureServerReviewRequestBody = {
  /**
   * The server URL the dossier describes.
   */
  target: string;
};

/** @internal */
export type EnsureServerReviewRequestBody$Outbound = {
  target: string;
};

/** @internal */
export const EnsureServerReviewRequestBody$outboundSchema: z.ZodMiniType<
  EnsureServerReviewRequestBody$Outbound,
  EnsureServerReviewRequestBody
> = z.object({
  target: z.string(),
});

export function ensureServerReviewRequestBodyToJSON(
  ensureServerReviewRequestBody: EnsureServerReviewRequestBody,
): string {
  return JSON.stringify(
    EnsureServerReviewRequestBody$outboundSchema.parse(
      ensureServerReviewRequestBody,
    ),
  );
}
